import ECharts from 'vue-echarts'
import 'echarts/lib/component/tooltip'
import 'echarts/lib/component/polar'
import 'echarts/lib/component/legend'
import 'echarts/lib/component/title'
import 'echarts/lib/component/dataset'
import 'echarts/map/js/world'
import 'zrender/lib/svg/svg'
export default {
  components: {
    'v-chart': ECharts
  },
  data () {
    return {
      colors: [
        '#c23531', 
        '#2f4554', 
        '#61a0a8', 
        '#d48265', 
        '#91c7ae', 
        '#749f83', 
        '#ca8622', 
        '#bda29a', 
        '#6e7074', 
        '#546570', 
        '#c4ccd3', 
        '#004DA1',
        '#009EA7',
        '#AACD03',
        '#F9BE00',
        '#EC6C00',
        '#A40081',
        '#0068B6',
        '#00A73B',
        '#FFD800',
        '#F29600',
        '#E5002D',
        '#541B85'
      ],
    }
  },
  // computed: {
  //   // colors
  // },
  // methods: {
  //   colorFun () {
  //     return `rgb(${Math.floor(Math.random() * 150)}, ${Math.floor(Math.random() * 150)}, ${Math.floor(Math.random() * 150)}`
  //   }
  // }
}